import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Fi from 'react-icons/fi';

import { InvoiceAdditional } from 'services/action';

import { Form } from 'ui/components';

import { Modal, Button } from 'react-bootstrap';

const initialState = {
  additionals: [
    {
      nominal: 0,
      note: '',
    },
  ],
};

export const FormAdditional = ({
  data,
  additional,
  onClose
}) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state?.Form);

  const [{ additionals }, setState] = React.useState(initialState);

  const $resetState = () => {
    setState({ ...initialState });
  };

  const handleSubmit = async (e) => {
    const payload = {
      invoice_id: data?.id,
      additionals
    };

    let req = null
    if (additional) {
      payload.additional = additionals[0]
      payload.additionals = null
      req = await Dispatch(InvoiceAdditional.$update(additional?.id, payload));
    } else {
      req = await Dispatch(InvoiceAdditional.$create(payload));
    }

    if (req?.message === 'success') {
      onClose();
    }
  };

  const $handleItemsChange = async (i, e) => {
    let newItems = [...additionals];
    newItems[i][e.target.name] = e.target.valueNumber
      ? e.target.valueNumber
      : e.target.value;

    setState((prevState) => ({ ...prevState, additionals: newItems }));
  };

  const $addMoreFields = async (i) => {
    setState((prevState) => ({
      ...prevState,
      additionals: [
        ...prevState?.additionals,
        {
          nominal: 0,
          note: '',
        },
      ],
    }));
  };

  const $removeField = async (i) => {
    let newItems = [...additionals];
    newItems.splice(i, 1);
    setState((prevState) => ({ ...prevState, additionals: newItems }));
  };

  React.useEffect(() => {
    if (!additional) {
      $resetState();
    }

    const additionals = [
      {
        note: additional?.note,
        nominal: additional?.nominal
      }
    ]

    setState((prevState) => ({ ...prevState, additionals: additionals }));
  }, [additional])

  return (
    <>
      <Modal.Body>
        <div className="border rounded">
          {additionals?.map((e, i) => (
            <div
              className="row align-items-end border-bottom py-2 m-0 flex-wrap"
              key={i}
            >
              <div className={`${!additional ? 'col-10' :'col-12'}`}>
                <div className="row m-0">
                  <div className="col-md-6">
                    <Form.Input
                      autoComplete="off"
                      label="Keterangan"
                      name="note"
                      type="text"
                      value={e?.note}
                      onChange={(e) => $handleItemsChange(i, e)}
                      error={StateForm?.errors[`additionals.${i}.note`]}
                    />
                  </div>
                  <div className="col-md-6">
                    <Form.Input
                      autoComplete="off"
                      label="Nominal"
                      name="nominal"
                      type="number"
                      value={e?.nominal}
                      onChange={(e) => $handleItemsChange(i, e)}
                      error={
                        StateForm?.errors[`additionals.${i}.nominal`]
                      }
                    />
                  </div>
                </div>
              </div>
              {!additional && (
                <div className="col-2 ps-0">
                  {i ? (
                    <button
                      type="button"
                      className="btn btn-danger rounded mb-3 p-0"
                      style={{ minHeight: 30, width: 36 }}
                      onClick={() => $removeField(i)}
                    >
                      <Fi.FiX />
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-primary rounded mb-3 p-0"
                      style={{ minHeight: 30, width: 36 }}
                      onClick={() => $addMoreFields()}
                    >
                      <Fi.FiPlus />
                    </button>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="row w-100">
            <div className="col">
              <Button variant="white" className="w-100" onClick={onClose}>
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="primary"
                className={StateForm?.loading ? ' btn-loading w-100' : 'w-100'}
                onClick={handleSubmit}
                disabled={StateForm?.loading}
              >
                Simpan
              </Button>
            </div>
          </div>
      </Modal.Footer>
    </>
  )

  // return (
  //   <div>
  //     <>
  //       <div>
  //         <div className="border rounded">
  //           <div className="mt-2 mb-2 mx-3 border-bottom">
  //             {isLoading ? (
  //               <div style={{ width: 250 }}>
  //                 <SkeletonText count={1} />
  //               </div>
  //             ) : (
  //               <label className={'form-label'}>Biaya Tambahan</label>
  //             )}
  //           </div>
  //           {isLoading ? (
  //             <div className="row py-2 m-0 px-2">
  //               {dummy?.map((d, i) => (
  //                 <div className="col-6" key={i}>
  //                   <SkeletonsForm count={1} />
  //                 </div>
  //               ))}
  //             </div>
  //           ) : (
  //             additional?.map((e, i) => (
  //               <div
  //                 className="row align-items-end border-bottom py-2 m-0 flex-wrap"
  //                 key={i}
  //               >
  //                 <div className="col-10">
  //                   <div className="row m-0">
  //                     <>
  //                       <div className="col-md-6">
  //                         <Form.Input
  //                           autoComplete="off"
  //                           label="Catatan"
  //                           name="note"
  //                           type="text"
  //                           value={e?.note}
  //                           onChange={(e) => $handleItemsChange(i, e)}
  //                           error={StateForm?.errors[`additionals.${i}.note`]}
  //                         />
  //                       </div>
  //                       <div className="col-md-6">
  //                         <Form.Input
  //                           autoComplete="off"
  //                           label="Nominal"
  //                           name="nominal"
  //                           type="number"
  //                           value={e?.nominal}
  //                           onChange={(e) => $handleItemsChange(i, e)}
  //                           error={
  //                             StateForm?.errors[`additionals.${i}.nominal`]
  //                           }
  //                         />
  //                       </div>
  //                     </>
  //                   </div>
  //                 </div>
  //                 <div className="col-2 ps-0">
  //                   {i ? (
  //                     <button
  //                       type="button"
  //                       className="btn btn-danger rounded mb-3 p-0"
  //                       style={{ minHeight: 36, width: 36 }}
  //                       onClick={() => $removeField(i)}
  //                     >
  //                       <Fi.FiX />
  //                     </button>
  //                   ) : (
  //                     <button
  //                       type="button"
  //                       className="btn btn-primary rounded mb-3 p-0"
  //                       style={{ minHeight: 36, width: 36 }}
  //                       onClick={() => $addMoreFields()}
  //                     >
  //                       <Fi.FiPlus />
  //                     </button>
  //                   )}
  //                 </div>
  //               </div>
  //             ))
  //           )}
  //         </div>
  //       </div>

  //       <div className="row m-0 mt-3 border-top pt-3">
  //         <div className="col-12">
  //           <FormSubtotal
  //             shipments={shipment}
  //             data={subTotal}
  //             setData={setData}
  //             additional={additional}
  //             isLoading={isLoading}
  //             invoice={invoice}
  //           />
  //         </div>
  //       </div>
  //     </>
  //   </div>
  // );
};
